module.exports = __webpack_public_path__ + "static/img/2_4_2.fc9bbfa2.jpg";